import React from 'react';
import { Button } from './Button';
import { Reveal } from './Reveal';
import { contactEmail } from '../data/navigation';
export function ContactPrompt() {
  return <section className="bg-white py-24 lg:py-28" data-id="element-109" data-mp="3n8lb2rcb88rd">
      <Reveal className="mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-12 lg:items-end lg:gap-12 lg:px-10" data-id="element-110" data-mp="51f51rjnkj7g">
        <div className="lg:col-span-7" data-id="element-111" data-mp="xh5xgubv8ee">
          <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-112" data-mp="eytjxmpxgzxn" />
          <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-113" data-mp="ewyvvzjd0rpc">
            Let’s start a conversation.
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink/75" data-id="element-114" data-mp="oowdbo0yofwi">
            Whether you’re hiring for a senior or specialist role, or exploring your next career
            opportunity, we’d be glad to hear from you.
          </p>
        </div>
        <div className="lg:col-span-5" data-id="element-115" data-mp="xmyk6k7dm2rp">
          <div className="flex flex-col gap-3 sm:flex-row lg:justify-end" data-id="element-116" data-mp="sqzpkevgfoiu">
            <Button to="/contact" data-id="element-117" data-mp="157use9ltf21l">Contact Us</Button>
            <Button to="/candidates#register" variant="outline" data-id="element-118" data-mp="1595xccqzyfua">
              Register Your Interest
            </Button>
          </div>
          <p className="mt-5 text-sm text-ink/70 lg:text-right" data-id="element-119" data-mp="1f5sf2so10qs3">
            Or email{' '}
            <a href={`mailto:${contactEmail}`} className="font-medium text-navy underline decoration-gold underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-dark" data-id="element-120" data-mp="1f856dwfocdht">
              {contactEmail}
            </a>
          </p>
        </div>
      </Reveal>
    </section>;
}